<!-- 兑换记录 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <div class="top">
        <el-row :gutter="20" style="width:100%">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-date-picker
                v-model="data"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" :offset="12">
            <div class="flex">
              <el-input
                placeholder="请输入内容"
                v-model="screenInput"
                clearable
                size="small"
              ></el-input>
              <el-button type="primary" size="small">搜索</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="cont">
        <el-table
          :data="tableData"
          size="small"
          :header-cell-style="setHeader"
          height="100%"
        >
          <el-table-column prop="index"></el-table-column>
          <el-table-column prop="info.real_name" label="用户"></el-table-column>
          <el-table-column prop="day" label="签到天数"></el-table-column>
          <el-table-column prop="credit" label="累计获得积分"></el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next, jumper"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { signlist } from "@/api/sign";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["app_id", "token"])
  },
  data() {
    return {
      data: "",
      screenInput: "",
      page: 1,
      total_num: 0,
      tableData: [],
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      }
    };
  },

  components: {},
  mounted() {
    this.getList();
  },
  methods: {
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getList();
    },
    getList() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        store_id: 0, //
        page: this.page
      };
      signlist(data).then(res => {
        console.log("订单列表", res);
        this.tableData = res.data.result;
        this.tableData.forEach((item, index) => {
          // if(this.page != 0)
          item.index = this.page !== 1 ? String(this.page - 1) + index : index;
        });
        this.total_num = res.data.total_num;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.padding {
  padding: 20px;
}
.content {
  width: 100%;
  height: 100%;
  .bodycontent {
    padding: 0 100px 0 52px;
    height: 100%;
    .top {
      height: 80px;
      padding: 20px 0;
    }
    .cont {
      height: calc(100% - 80px);
      display: flex;
      flex-direction: column;
      .el-table {
        width: 100%;
        flex: 1;
      }
      .page {
        height: 60px;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
